import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-fluid p-field p-col-9" }
const _hoisted_3 = { for: "id" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-field p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_ValueListForm = _resolveComponent("ValueListForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Squeeze.Locators.Value")) + ": ", 1),
        _createVNode(_component_Dropdown, {
          id: "id",
          modelValue: _ctx.valueListEntryDropzone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueListEntryDropzone) = $event)),
          options: _ctx.fullValueList,
          onChange: _ctx.onChangeValueList,
          loading: _ctx.loading
        }, {
          value: _withCtx((slotProps) => [
            (slotProps.value.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, _toDisplayString(slotProps.value.value) + " (" + _toDisplayString(slotProps.value.description) + ")", 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.Locators.Tabs.NoValuesAvailable')), 1))
          ]),
          option: _withCtx((slotProps) => [
            _createElementVNode("span", null, _toDisplayString(slotProps.option.value) + " (" + _toDisplayString(slotProps.option.description) + ")", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "options", "onChange", "loading"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          style: {"width":"100%"},
          for: "id"
        }, " ", -1)),
        _withDirectives(_createVNode(_component_Button, {
          type: "button",
          icon: "mdi mdi-plus",
          class: "p-button p-ml-2",
          label: _ctx.fullValueList.length === 0 ? _ctx.$t('Squeeze.Locators.Tabs.CreateValue') : null,
          onClick: _ctx.openNewEntry
        }, null, 8, ["label", "onClick"]), [
          [_directive_tooltip, _ctx.$t('Squeeze.Locators.Tabs.CreateValue')]
        ]),
        (_ctx.fullValueList.length > 0)
          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
              key: 0,
              type: "button",
              icon: "mdi mdi-pencil",
              class: "p-button p-ml-2",
              onClick: _ctx.openEditDialog
            }, null, 8, ["onClick"])), [
              [_directive_tooltip, _ctx.$t('Squeeze.Locators.Tabs.ChangeValue')]
            ])
          : _createCommentVNode("", true),
        (_ctx.fullValueList.length > 0)
          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
              key: 1,
              type: "button",
              icon: "mdi mdi-delete",
              class: "p-button p-ml-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteDialog = true))
            }, null, 512)), [
              [_directive_tooltip, _ctx.$t('Squeeze.Locators.Tabs.DeleteValue')]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveValueListItem,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_ValueListForm, {
              valueListEntry: _ctx.valueListEntry,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage
            }, null, 8, ["valueListEntry", "onUpdate", "showErrorMessage"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText"])
  ], 64))
}